import { FC } from "react";
import { ConnectProto } from "@racoon/api";
import { Namespace, useT } from "@racoon/i18n";
import { ContainerGroupSchedules } from "~/features/container-group-schedule/ui/container-group-schedules";

type Props = {
  locationId?: number | string;
  containerGroups?: ConnectProto.ContainerGroup[];
};

/** The schedule table is the only schedule source: cron column entries show there as mirrored rows. */
export const ScheduleBlock: FC<Props> = ({ locationId, containerGroups = [] }) => {
  const t = useT();

  if (!locationId) {
    return (
      <div className="flex justify-center items-center h-full text-sm text-gray-500">
        {t(Namespace.PickupLocation, "schedule.saveLocationFirst")}
      </div>
    );
  }

  return (
    <div className="w-full h-full overflow-auto pr-2 pb-4">
      <div className="flex flex-col gap-4 min-w-[950px] pb-6">
        <ContainerGroupSchedules locationId={locationId} containerGroups={containerGroups} />
      </div>
    </div>
  );
};
